import { useEffect, useState } from "react"
import { useDispatch, useSelector } from 'react-redux';
import { const_var,params } from "../../redux/reducers/reducer";
import { handleDealerDiscountBannerVisible } from "../../action";

const TopBanner = () =>{
    const state = useSelector((state) => state.reducer);
    const [isBannerShow, setBannerShow] = useState(localStorage.getItem('isBannerCollapsed') != undefined ? false : true)   
    const [hideContent, setHideContent] = useState(localStorage.getItem('isBannerCollapsed') != undefined ? false : true)   
    const dispatch = useDispatch()

    const redirectTOCRM = (manufacturer_id) => {
        // window.open(`${state.source}/manufacturers/${manufacturer_id}`,"_self")
        // window.open(`${const_var.crmSetting.source}/manufacturers/${manufacturer_id}`,"_self")
        window.open(`${const_var.crmSetting.web_url}/manufacturers/${manufacturer_id}`,"_blank")
    }

    const collapseBanner = () => {
        if(isBannerShow == true){
            localStorage.setItem('isBannerCollapsed', true)
            setTimeout(() => {
                setHideContent(false)
            }, 100);
            setBannerShow(false)
            dispatch(handleDealerDiscountBannerVisible(false))
        }
        else{
            setHideContent(true)
            setBannerShow(true)
            dispatch(handleDealerDiscountBannerVisible(true))
        }
    }

    useEffect(()=>{
        if(localStorage.getItem('isBannerCollapsed') != undefined){
            setBannerShow(false)
            setHideContent(false)
            dispatch(handleDealerDiscountBannerVisible(false))
        } else {
            if(((const_var.crmSetting.companyType != 'manufacturer') || (const_var.crmSetting.companyType == 'manufacturer' && const_var.crmSetting.company_mnf_id == params.m_s_n)) && hideContent) {
                dispatch(handleDealerDiscountBannerVisible(true))
            } else {
                dispatch(handleDealerDiscountBannerVisible(false))
            }
        }
    },[params.m_s_n, params.p_s_n])
    let checkOffer = false;
    if(state.discount_banner!=true)
    {
        checkOffer = true;
    }
    if(state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount']!=undefined)
    {
      if(state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n]==undefined && state.const_var.crmSetting.companyType != 'manufacturer')
      {
        checkOffer = true;
      }
      if(state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n]!=undefined && state.const_var.crmSetting.companyType == 'manufacturer')
      {
        if(state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n].length==0 && !state.discount_banner)
        {
            checkOffer = true;
        }
        if(const_var.crmSetting.companyType == 'manufacturer' && const_var.crmSetting.company_mnf_id !== params.m_s_n && checkOffer == true){
            checkOffer = false
        }
      }
    } 
    //console.log(state.discount_banner , state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'],state.const_var.stateManufacturerNewDiscount,const_var.crmSetting.company_mnf_id , params.m_s_n,"state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount']")
    // if(state.discount_banner && checkOffer)
    // {
    //     checkOffer = false;
    // }
    let lapSidingMessage = false
    return <>
        {
            ((const_var.crmSetting.companyType != 'manufacturer') || (const_var.crmSetting.companyType == 'manufacturer' && const_var.crmSetting.company_mnf_id == params.m_s_n) || checkOffer) &&
            // <div className={`top-header-banner ${const_var.loginSession == true && state.discount_Offers_all?.length == 0 ? '' : 'd-none'} ${isBannerShow ? '' : 'collapse-banner'}`}>
            <>
                {
                    lapSidingMessage && window.innerWidth >= 515 
                    ?
                        <div className={`top-header-banner ${const_var.loginSession == true && checkOffer ? 'd-none' : 'd-none'} ${isBannerShow ? '' : ''} ${const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' ? ' explor-mnf-bnr' : ''}`}>
                                <span className={`text-uppercase ${const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' ? ' hide-resp' : ''}`}>Unlock the full lot—<span className="text-capitalize">add Sensei Sheds for just $100/month and give your customers more ways to say yes.</span></span> 
                                <a className={`additional-link underline ${const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' ? 'hide-resp' : ''}`} style={{top: -1}}  href={"mailto:info@senseidigital.com"}>CONTACT US TODAY  <i className="icon-arrow-thin-right hide-resp"></i></a>  
                        </div>
                    :
                        <div className={`top-header-banner ${const_var.loginSession == true && checkOffer ? '' : 'd-none'} ${isBannerShow ? '' : 'collapse-banner'} ${const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' ? ' explor-mnf-bnr' : ''}`}>
                            {
                                hideContent &&
                                <>

                                    <span className={`text-uppercase ${const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' ? ' hide-resp' : ''}`}> <i className="icon-offer-tag hide-resp"></i>offering building discounts?</span> 
                                    {
                                        const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' &&
                                        <a className="additional-link underline for-resp ml-0"  onClick={() => {redirectTOCRM(params.m_s_n)}}>Add Building Discounts  <i className="icon-arrow-thin-right hide-resp"></i></a>
                                    }
                                    <a className={`additional-link underline ${const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' ? 'hide-resp' : ''}`}  onClick={() => {redirectTOCRM(params.m_s_n)}}>Add them here  <i className="icon-arrow-thin-right hide-resp"></i></a>
                                    {
                                        const_var.crmSetting.companyType!=undefined && const_var.crmSetting.companyType!='manufacturer' && 
                                        <>
                                            <div className="link-divider"></div>
                                            <a className="additional-link2 underline" onClick={() => {window.open(const_var.crmSetting.web_url+'/manufacturer_active_discount', '_blank')}}>Explore Manufacturer’s Deals  <i className="icon-arrow-thin-right hide-resp"></i></a>
                                        </>
                                    }
                                    <span className="cross-banner" onClick={()=>collapseBanner()}><i className="icon-close"></i></span>
                                </>
                            }
                            {
                                !isBannerShow &&
                                <span className="bottom-bnr-cta" onClick={()=>collapseBanner()}>% <i className="icon-caret-down"></i></span>
                            }
                        </div>
                    }
            </>
        }
    </>
}

export default TopBanner;